const local = {
  instruction: "Upgrade Your Castle",
  races: ["Human", "Elf", "Orc", "Gnome", "Undead"],
  scale: ["LITTLE", "MEDIUM", "LARGE"],
  serialNumber: "Serial Number",
  specialid: "Special ID",
  race: "BREED",
  economic: "ECONOMIC",
  military: "MILITARY",
  cards: [
    "Castle Size",
    "Castle Style",
    "Castle Color",
    "Logo Style",
    "Logo Color",
    "Logo Position",
    "Race",
    "Special ID",
  ],
  hint: "Hint",
  hintDetail:
    "You can annex the land once in 10 seconds. If you want to change the style of the castle, you can go back to Lesson 1 Chapter 1 and edit your castle again.",
  castleInformation: "Castle Info",
  castleLevel: "Castle Level",
  castleEconomy: "Economic power",
  annexLand: "Annex a Land",
  annexPrefix: "Please wait ",
  annexSuffix: " second(s) to continue",
  random: "Land randomly generated by the system: type ",
  annex: "Successful annexation! Economic Power has increased to ",
  levelup: "Level up! Now the new level of you castle has been ",
};

export { local };
